const INITIAL_STATE = {
	eids: '',
	domain: 'physical',
	analytics: {},
	quantity: 0
};

export default function buyNow(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case 'BUY_NOW_REQUEST':
			if (action.domain === 'ff') {
				action.domain = 'FLIPKART_FIRST';
			}
			return Object.assign({}, state, {
				eids: action.eids,
				domain: action.domain || INITIAL_STATE.domain,
				analytics: action.analytics,
				quantity: action.quantity,
				customPayload: action.customPayload
			});
		case 'BUY_NOW_RESET':
			return INITIAL_STATE;
		case 'BUY_EGV_REQUEST':
			action.egvRequestBody.egvRequests = action.egvRequestBody.egvRequests.map(egv => {
				return {
					amount: encodeURIComponent(egv.amount),
					senderName: encodeURIComponent(egv.senderName),
					receiverEmailId: encodeURIComponent(egv.receiverEmailId),
					receiverName: encodeURIComponent(egv.receiverName),
					noOfVouchers: encodeURIComponent(egv.noOfVouchers),
					message: encodeURIComponent(egv.message)
				};
			});
			return Object.assign(
				{},
				{
					domain: 'egv',
					egvData: action.egvRequestBody
				}
			);
		default:
			return state;
	}
}
